// jshint module: true

// Polyfill for document.scrollingElement
if (!document.scrollingElement) {
  document.scrollingElement = document.documentElement.scrollHeight > document.body.scrollheight && document.compatMode.indexOf('CSS1') === 0 ? document.documentElement : document.body;
}



// WEBPACK FOOTER //
// ./bluemountain/assets/scripts/vendor/fabrique/polyfills/get-scrolling-element.js